<template>
    <div class="step-item" :class=[nodeClass]>
      <div class="stop-left">
        <div class="step-num" v-if="!hiddenStepsNum">{{stepNum + 1}}</div>
        <div class="step-line"></div>
      </div>
      <div class="step-main">
        <slot></slot>
      </div>
    </div>
</template>

<script>
import {i18n} from '@/utils/i18n'

export default {
  name: 'Step',
  i18n,
  components: {
  },
  props: {
    active: Number,
    title: String,
    label: String,
    nodeClass: String,
    showCheckbox: Boolean,
    definition_id: Number,
    checked: Boolean,
    hiddenStepsNum: Boolean
  },
  data () {
    return {
      stepNum: 1
    }
  },
  mounted () {
    this.stepNum = this.$parent.$slots.default.indexOf(this.$vnode)
  },
  methods: {}
}
</script>
<style lang="postcss">
@import 'variables';
.step-item {
  & .step-main {
    display: flex;
    flex-direction: column;
  }
  & .stop-left {
    &.checkbox-box {
      width: 16px !important;
      & .step-num {
        width: 16px !important;
        height: 16px !important;
        position: relative;

        & .van-checkbox {
          & .van-checkbox__icon {
            height: 16px;
            line-height: 16px;
            position: absolute;
            left: -1px;
            top: -1px;
            & .van-icon {
              width: 16px;
              height: 16px;
            }
          }
        }
      }

      & .step-line {
        margin-left: 8px;
      }

      &::before {
        left: 8px;
      }
    }
  }
}

</style>
